import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=2335ffc6&scoped=true&"
import script from "./tag.vue?vue&type=script&lang=js&"
export * from "./tag.vue?vue&type=script&lang=js&"
import style0 from "./tag.vue?vue&type=style&index=0&id=2335ffc6&lang=scss&scoped=true&"
import style1 from "./tag.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335ffc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2335ffc6')) {
      api.createRecord('2335ffc6', component.options)
    } else {
      api.reload('2335ffc6', component.options)
    }
    module.hot.accept("./tag.vue?vue&type=template&id=2335ffc6&scoped=true&", function () {
      api.rerender('2335ffc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tag.vue"
export default component.exports